import { CellValue } from 'src/common/types/CellValue.ts';
import { LocaleValuesFragment } from 'src/generated/operations.ts';
import { isLocaleValuesFragment } from 'src/common/types/isLocaleValuesFragment.ts';

export const isArrayOfLocaleValuesFragment = (
    value: CellValue,
): value is Array<LocaleValuesFragment | null | undefined> => Array.isArray(value) && value
    .filter((v) => isLocaleValuesFragment(v) || v === null || v === undefined).length === value.length;
